import React from "react";
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import $ from "jquery";
window.$ = window.jQuery = $;

import 'bootstrap/dist/js/bootstrap.js';
import './bootstrap';

import "monday-ui-react-core/tokens";

import { AuthProvider } from "./react/auth/useAuth.jsx";

import Main from "./react/main.jsx";

const rootElement = document.getElementById("react");
const root = ReactDOM.createRoot(rootElement);

root.render(
    <BrowserRouter>
        <AuthProvider>
            <Main />
        </AuthProvider>
    </BrowserRouter>
);